"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "certaldo": {
    "4750be06": [{
      "hkey": "6980ba7f",
      "slug": "certaldo",
      "name": "Certaldo",
      "primary": true,
      "skipSearch": false
    }],
    "bagnano": [{
      "hkey": "6980ba7f",
      "slug": "certaldo",
      "name": "Certaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eb40824b": [{
      "hkey": "6980ba7f",
      "slug": "certaldo",
      "name": "Certaldo",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-a-maiano": [{
      "hkey": "6980ba7f",
      "slug": "certaldo",
      "name": "Certaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;